import {useEffect, useState} from "react";
import {Table, Input, Form, Space, Row, Col, Typography} from "antd";
import React from "react";
import columnsNearPGP from "types/config/near-pgd-colums";
import {
  glassesPrescriptionColumns1,
  glassesPrescriptionColumns2,
} from "types/config/glasses-prescription ";
import glassesPrescription from "__mocks__/glassesPrescription";
import {
  glassesBillColumns1,
  glassesBillColumns2,
} from "types/config/glasses-bill";
import {useAppSelector} from "redux/hooks";
import {TT_DON_KINH} from "types/enums";

const nearPgd = [
  {
    key: 1,
    none: "Xa",
    Sph: "",
    Cyl: "",
    Axis: "",
    Vision: "",
  },
  {
    key: 2,
    none: "Add",
    Sph: "",
    Cyl: "",
    Axis: "",
    Vision: "",
  },
  {
    key: 3,
    none: "Gần",
    Sph: "",
    Cyl: "",
    Axis: "",
    Vision: "",
  },
];

const Left = ({form}) => {
  const statusBill = useAppSelector(state => state.glassKiot.statusBill);
  const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    if (statusBill != TT_DON_KINH.CHUA_BAN) {
      setDisabled(true);
    } else setDisabled(false);
  }, [statusBill]);

  return (
    <Col key={1} xl={12} md={12} sm={24} xs={24}>
      <Space direction="vertical" size={"middle"}>
        <Table
          dataSource={nearPgd}
          columns={glassesBillColumns1("left", form, disabled)}
          bordered
          pagination={false}
          title={() => "Mắt trái"}
        />
        <Table
          dataSource={glassesPrescription.tb2}
          columns={glassesBillColumns2("left", disabled)}
          bordered={true}
          pagination={false}
          showHeader={false}
        />
      </Space>
    </Col>
  );
};

export default Left;
